import React from "react";
import PropTypes from "prop-types";
import DigiFormItem from "../DigiForm/DigiFormItem";

class SlideInspectionTasks extends React.Component {
  state = {
    loading: false,
    fieldErrors: {},
    slideInspectionTasks: this.props.slideInspectionTasks
  };

  componentWillReceiveProps(newProps) {
    if(this.props != newProps) {
      this.setState({
        slideInspectionTasks: newProps.slideInspectionTasks
      });
    }
  }

  render() {
    const {
      loading,
      slideInspectionTasks,
      fieldErrors
    } = this.state;

    const {
      requiredOptions,
      formName,
      onChange
    } = this.props;

    return (
      <table className="table table-bordered">
        <tbody>
        {slideInspectionTasks && (slideInspectionTasks.map((task, index) =>
          <tr>
            <td>
              <DigiFormItem
                key={(task.id || task._id) + "-toggle"}
                formFieldKey={(task.id || task._id) + "-toggle"}
                formField={{
                  "type": "toggle",
                  "label_true": "OK",
                  "label_false": "Problem",
                  "value": task.completed || false,
                  "required": false,
                  "enabled": true
                }}
                index={index}
                fieldErrors={fieldErrors}
                onChange={this.handlerChangeField}
              />
          </td>
          <td>
            <p>{task.task_name}</p>
            <DigiFormItem
              key={(task.id || task._id) + "-note"}
              formFieldKey={(task.id || task._id) + "-note"}
              formField={{
                "type": "textarea",
                "label": "",
                "placeholder": "Please leave a detailed description.....",
                "value": task.note || "",
                "required": false,
                "enabled": true
              }}
              index={index}
              fieldErrors={fieldErrors}
              onChange={this.handlerChangeField}
            />
          </td>
        </tr>
        ))}
      </tbody>
    </table>
    );
  }

  handlerChangeField = (value, index, key) => {
    const slideInspectionTasks = this.state.slideInspectionTasks;
    slideInspectionTasks[index][key] = value;

    this.setState({ slideInspectionTasks: slideInspectionTasks, fieldErrors: {} });
    this.props.onChange(slideInspectionTasks, "slide_inspection_tasks_attributes");
  };
}

SlideInspectionTasks.propTypes = {
  slideInspectionTasks: PropTypes.array,
  fieldTypes: PropTypes.object,
  requiredOptions: PropTypes.object,
  fieldErrors: PropTypes.object,
  onRefreshSorting: PropTypes.func
};

export default SlideInspectionTasks;
